const events = {
  data: {
    events: [      
      {
        title: 'TRAINING',
        subtitle: 'Business Plan Competition',
        description: 'Training to Develop Business Financials: Facilitated by Small Business Development Center (SBDSC)',
        time: null,
        date: '2018-10-29',
        topic: 'Business Plan Competition'
      },
      {
        title: 'SUBMIT',
        subtitle: 'Business Plan Competition',
        description: 'Submit completed business plan to: economic.development@sdsmt.edu',
        time: null,
        date: '2018-11-16',
        topic: 'Business Plan Competition'
      },
      {
        title: 'ANNOUNCEMENT',
        subtitle: 'Business Plan Competition',
        description: 'Finalists announced.',
        time: null,
        date: '2018-11-19',
        topic: 'Business Plan Competition'
      },
      {
        title: 'PITCHES',
        subtitle: 'Business Plan Competition',
        description: 'Finalist Pitches and awards',
        time: null,
        date: '2018-12-1',
        topic: 'Business Plan Competition'
      }
    ]
  }
}

const DashboardStore = {
  data: {
    Events: events
  }
}

export default DashboardStore;


// WEBPACK FOOTER //
// ./src/stores/DashboardStore.js